import { ReactElement, SyntheticEvent } from 'react';
import ButtonGeneral from 'students/views/shared/components/ButtonGeneral';
import styled from 'styled-components';
import { Translate } from 'i18n';
import FinishIcon from '../../assets/pause.svg';
import MicrophoneIcon from '../../assets/microphone.svg';
import PauseIcon from '../../assets/pause.svg';
import PlayIcon from '../../assets/play.svg';
import VerticalDivider from '../../assets/vertical-divider.svg';
import { AudioState } from './types';
import { recordingStatusEnum } from './useAudioRecorder';

interface IActionButtonProps {
  status: recordingStatusEnum;
  audioPlayStatus: AudioState;
  onClick?: (e: SyntheticEvent) => void;
  node: ReactElement;
}

export const ActionButton: React.FC<IActionButtonProps> = ({
  status,
  audioPlayStatus,
  onClick,
  node
}) => {
  let btnInner: ReactElement | null = null;

  const finishBtn = (
    <div className="ln-flex ln-items-center ln-gap-3 ln-p-1.5 ln-bg-white ln-rounded-[100px] ln-shadow-pill">
      <SPulsingWrapper>
        <SFinishDiv>
          <img src={FinishIcon} alt="stop" />
        </SFinishDiv>
      </SPulsingWrapper>
      {node}
    </div>
  );

  const isPlaying = audioPlayStatus === AudioState.Playing;
  const playBtn = (
    <div className="ln-flex ln-items-center ln-gap-2 ln-p-1.5 ln-bg-white ln-rounded-[100px] ln-shadow-pill">
      <SRecordDiv>
        <img src={isPlaying ? PauseIcon : PlayIcon} alt={isPlaying ? 'pause' : 'play'} />
      </SRecordDiv>
      {!isPlaying && (
        <p className="ln-text-black ln-font-semibold ln-text-base ln-mr-2">
          <Translate str="frontend.media_player.audio_player.aria_play_button" />
        </p>
      )}
      <img src={VerticalDivider} alt="divider" />
      {node}
    </div>
  );

  switch (status) {
    case recordingStatusEnum.EMPTY:
      btnInner = recordBtn;
      break;
    case recordingStatusEnum.FINISHED:
      btnInner = playBtn;
      break;
    case recordingStatusEnum.RECORDING:
    case recordingStatusEnum.PAUSED:
      btnInner = finishBtn;
      break;
    default:
      break;
  }
  if (!btnInner) return null;

  return (
    <SActionButtonContainer status={status} onClick={onClick}>
      {btnInner}
    </SActionButtonContainer>
  );
};

const SActionButtonContainer = styled(ButtonGeneral)<{ status: recordingStatusEnum }>`
  cursor: pointer;
  background: transparent;
  border-radius: 50%;
`;

const SRecordDiv = styled.div`
  width: 60px;
  height: 60px;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0.9) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  &:active {
    box-shadow: none;
  }
`;

const recordBtn = (
  <div className="ln-flex ln-items-center ln-gap-2 ln-p-1.5 ln-bg-black ln-rounded-[100px] ln-shadow-pill">
    <SRecordDiv>
      <img src={MicrophoneIcon} alt="start recording" />
    </SRecordDiv>
    <p className="ln-text-white ln-font-semibold ln-text-base ln-mr-4">
      Tap and speak...
    </p>
  </div>
);

const SFinishDiv = styled.div`
  padding: 6px;
  background: #fff;
  border-radius: 50%;
  position: relative;
  z-index: 1;
`;

const SPulsingWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #ff5858;
    animation: pulse 1.5s ease-out infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.6;
    }
    100% {
      transform: scale(1.5);
      opacity: 0;
    }
  }
`;
